import { MASSIVE_STATUS, MassiveStatus } from 'services/MassiveService';

interface StatusView {
  label: string;
  color: string;
}

const VIEWS: Record<string, StatusView> = {
  [MASSIVE_STATUS.SPAWNING]: { label: 'Procesando', color: 'processing' },
  [MASSIVE_STATUS.CREATING]: { label: 'Creando paquetes', color: 'processing' },
  [MASSIVE_STATUS.LABELING]: {
    label: 'Generando etiquetas',
    color: 'processing',
  },
  [MASSIVE_STATUS.READY]: { label: 'Listo', color: 'success' },
  [MASSIVE_STATUS.PARTIAL]: { label: 'Parcial', color: 'warning' },
  [MASSIVE_STATUS.FAILED]: { label: 'Falló', color: 'error' },
  [MASSIVE_STATUS.CANCELLED]: { label: 'Eliminada', color: 'default' },
  [MASSIVE_STATUS.STOPPED]: { label: 'Interrumpida', color: 'error' },
};

export const statusView = (status: MassiveStatus): StatusView =>
  VIEWS[status] ?? { label: status, color: 'default' };

export const STATUS_OPTIONS = [
  { value: MASSIVE_STATUS.SPAWNING, label: 'Procesando' },
  { value: MASSIVE_STATUS.CREATING, label: 'Creando paquetes' },
  { value: MASSIVE_STATUS.LABELING, label: 'Generando etiquetas' },
  { value: MASSIVE_STATUS.READY, label: 'Listo' },
  { value: MASSIVE_STATUS.PARTIAL, label: 'Parcial' },
  { value: MASSIVE_STATUS.FAILED, label: 'Falló' },
  { value: MASSIVE_STATUS.STOPPED, label: 'Interrumpida' },
];
